import { put, call, all, takeLatest } from 'redux-saga/effects'
import services from '../../services'

import {
  GetOneCompany,
  GET_ONE_COMPANY,
  GET_ONE_COMPANY_BY_SLUG,
  GET_ONE_COMPANY_ERROR,
  GET_ONE_COMPANY_SUCCESS,
} from '../types/company/get-one'

import {
  EditCompany,
  EDIT_COMPANY,
  EDIT_COMPANY_ERROR,
  EDIT_COMPANY_SUCCESS,
} from '../types/company/edit'

import {
  EditCompanyBusinessName,
  EDIT_COMPANY_BUSINESS_NAME,
  EDIT_COMPANY_BUSINESS_NAME_ERROR,
  EDIT_COMPANY_BUSINESS_NAME_SUCCESS,
} from '../types/company/edit-business-name'

import {
  EditCompanyBigLogo,
  EDIT_COMPANY_BIG_LOGO,
  EDIT_COMPANY_BIG_LOGO_ERROR,
  EDIT_COMPANY_BIG_LOGO_SUCCESS,
} from '../types/company/edit-big-logo'

import {
  EditCompanySmallLogo,
  EDIT_COMPANY_SMALL_LOGO,
  EDIT_COMPANY_SMALL_LOGO_ERROR,
  EDIT_COMPANY_SMALL_LOGO_SUCCESS,
} from '../types/company/edit-small-logo'

function* getOneCompany({ payload }) {
  try {
    const { response, error } = yield call(services.company.getOne, payload)
    if (error) {
      yield put({
        type: GET_ONE_COMPANY_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ONE_COMPANY_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_COMPANY_ERROR,
      payload: 'Error al obtener contendio',
    })
  }
}

function* getOneCompanyBySlug({ payload }) {
  try {
    const { response, error } = yield call(services.company.getBySlug, payload)
    if (error) {
      yield put({
        type: GET_ONE_COMPANY_ERROR,
        payload: error,
      })
    } else {
      yield put({
        type: GET_ONE_COMPANY_SUCCESS,
        payload: response,
      })
    }
  } catch {
    yield put({
      type: GET_ONE_COMPANY_ERROR,
      payload: 'Error al obtener contendio',
    })
  }
}

function* editCompany({ payload }) {
  try {
    const { response, error } = yield call(services.company.edit, payload)
    if (error) {
      yield put({
        type: EDIT_COMPANY_ERROR,
        payload: error,
      })
    } else {
      yield all([
        put({ type: EDIT_COMPANY_SUCCESS, payload: response }),
        put({ type: GET_ONE_COMPANY_SUCCESS, payload: response })
      ])
    }
  } catch {
    yield put({
      type: EDIT_COMPANY_ERROR,
      payload: 'Error al editar el contenido.',
    })
  }
}

function* editCompanyBusinessName({ payload }) {
  try {
    const { response, error } = yield call(services.company.edit, payload)
    if (error) {
      yield put({
        type: EDIT_COMPANY_BUSINESS_NAME_ERROR,
        payload: error,
      })
    } else {
      yield all([
        put({ type: EDIT_COMPANY_BUSINESS_NAME_SUCCESS, payload: response }),
        put({ type: GET_ONE_COMPANY_SUCCESS, payload: response })
      ])
    }
  } catch {
    yield put({
      type: EDIT_COMPANY_BUSINESS_NAME_ERROR,
      payload: 'Error al editar el nombre de la empresa.',
    })
  }
}

function* editCompanyBigLogo({ payload }) {
  try {
    const { response, error } = yield call(services.company.edit, payload)
    if (error) {
      yield put({
        type: EDIT_COMPANY_BIG_LOGO_ERROR,
        payload: error,
      })
    } else {
      yield all([
        put({ type: EDIT_COMPANY_BIG_LOGO_SUCCESS, payload: response }),
        put({ type: GET_ONE_COMPANY_SUCCESS, payload: response })
      ])
    }
  } catch {
    yield put({
      type: EDIT_COMPANY_BIG_LOGO_ERROR,
      payload: 'Error al editar el logo grande.',
    })
  }
}

function* editCompanySmallLogo({ payload }) {
  try {
    const { response, error } = yield call(services.company.edit, payload)
    if (error) {
      yield put({
        type: EDIT_COMPANY_SMALL_LOGO_ERROR,
        payload: error,
      })
    } else {
      yield all([
        put({ type: EDIT_COMPANY_SMALL_LOGO_SUCCESS, payload: response }),
        put({ type: GET_ONE_COMPANY_SUCCESS, payload: response })
      ])
    }
  } catch {
    yield put({
      type: EDIT_COMPANY_SMALL_LOGO_ERROR,
      payload: 'Error al editar el logo pequeño.',
    })
  }
}

/**
 * Watchers
 */
export default function* applicant() {
  yield takeLatest<GetOneCompany>(GET_ONE_COMPANY, getOneCompany)
  yield takeLatest<GetOneCompany>(GET_ONE_COMPANY_BY_SLUG, getOneCompanyBySlug)
  yield takeLatest<EditCompany>(EDIT_COMPANY, editCompany)
  yield takeLatest<EditCompanyBusinessName>(EDIT_COMPANY_BUSINESS_NAME, editCompanyBusinessName)
  yield takeLatest<EditCompanySmallLogo>(EDIT_COMPANY_SMALL_LOGO, editCompanySmallLogo)
  yield takeLatest<EditCompanyBigLogo>(EDIT_COMPANY_BIG_LOGO, editCompanyBigLogo)
}
